import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import QrCode2Icon from '@mui/icons-material/QrCode2';

import { MenuItem } from 'types/global';

type Props = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function GenerateCode({ selected, onSelect, open }: Props) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/generate"
			selected={selected === MenuItem.GenerateCode}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.GenerateCode)}
		>
			<ListItemIcon>
				<QrCode2Icon />
			</ListItemIcon>
			{open && <ListItemText primary={t('access:generate_code')} />}
		</ListItem>
	);
}
